<template>
  <video ref="video" class="carousel__item-video" :loop="loop" :muted="muted">
    <source :src="item.webm" type="video/webm" />
    <source :src="item.mp4" type="video/mp4" />

    <p v-if="fallback" class="carousel__item-video__fallback">
      <a :href="item.mp4 || item.webm">{{ fallback }}</a>
    </p>
  </video>
</template>

<script>
export default {
  name: 'SanitasCarouselItemVideo',

  props: {
    item: {
      type: Object,
      required: true,
      // Props:
      //   webm: String
      //   mp4: String
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    muted: {
      type: Boolean,
      default: false,
    },
    loop: {
      type: Boolean,
      default: false,
    },
    fallback: {
      type: String,
      default: null,
    },
  },

  watch: {
    isActive(next) {
      if (next) {
        this.$refs.video.play()
      } else {
        this.$refs.video.pause()
      }
    },
  },

  mounted() {
    if (this.isActive) {
      this.$refs.video.play()
    }
  },
}
</script>

<style lang="postcss" scoped>
.carousel__item-video {
  height: 100%;
}
</style>
